/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2023, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import { Component, Inject } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { DialogConfig, DialogRef } from 'src/aero/aero-dialog/types';

/**
 * This is an example of a custom content component for standard Aero dialogs.
 */
@Component({
  selector: 'bulb-test-custom-dialog-content',
  templateUrl: './test-custom-dialog-content.component.html',
  standalone: false,
})
export class TestCustomDialogContentComponent {

  primaryDisabled: boolean = false;

  config: DialogConfig;

  constructor(
    @Inject('DialogRef') private dialogRef:DialogRef,
    public dialogConfig: DynamicDialogConfig,
  ) {
    this.config = dialogConfig as DialogConfig;
  }

  updatePrimary(): void {
    this.dialogRef.setPrimaryDisabled(this.primaryDisabled);
  }
}
